/* eslint no-shadow: ["error", { "allow": ["state"] }] */

const state = {
  user: {},
};

const getters = {};

const actions = {
  userSignedIn({ commit }, data) {
    commit('ADD_USER', data);
  },
};
const mutations = {
  ADD_USER(state, data) {
    state.user = data.user;

    // if there is no name use the email
    if (data.user.displayName == null) {
      state.user.displayName = data.user.email;
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
